import React, {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {TextProps} from 'components/text/types';
import {Text} from 'components/text';

type Props = Omit<TextProps, 'kind'>;

/**
 * @deprecated Use MUI Tooltip instead.
 */
export const TooltipText: React.FC<React.PropsWithChildren<Props>> = props => {
  const {palette} = useTheme();
  const sx = useMemo(() => ({color: palette.text.primary}), [palette]);

  return <Text {...props} sx={sx} />;
};
